import { defaultHomeSliceName } from '../slices/default-home.slice';
export const selectDefaultHomeState = ({
  [defaultHomeSliceName]: defaultHomeState
}) => defaultHomeState;